import React, { useEffect, useState } from "react";

function BootLoader({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [line, setLine] = useState(0);

  const lines = [
    "INITIALIZING E-OPS SYSTEM",
    "Loading security modules...",
    "Verifying credentials...",
    "Access granted."
  ];

  useEffect(() => {
    const progressTimer = window.setInterval(() => {
      setProgress((value) => {
        const next = Math.min(100, value + Math.ceil(Math.random() * 8));
        if (next >= 100) {
          window.clearInterval(progressTimer);
          window.setTimeout(onComplete, 550);
        }
        return next;
      });
    }, 110);

    const lineTimer = window.setInterval(() => {
      setLine((value) => Math.min(lines.length - 1, value + 1));
    }, 520);

    const skip = (event) => {
      if (event.code === "Space" || event.type === "pointerdown") {
        onComplete();
      }
    };

    window.addEventListener("keydown", skip);
    window.addEventListener("pointerdown", skip);

    return () => {
      window.clearInterval(progressTimer);
      window.clearInterval(lineTimer);
      window.removeEventListener("keydown", skip);
      window.removeEventListener("pointerdown", skip);
    };
  }, [lines.length, onComplete]);

  return (
    <div className="boot-loader" role="dialog" aria-label="E-OPS system boot loader">
      <div className="boot-panel">
        <div className="boot-meta">E-OPS BIOS // v7.03</div>
        <h1>{lines[line]}</h1>
        <div className="boot-log" aria-live="polite">
          {lines.slice(0, line + 1).map((item) => (
            <p key={item}>&gt; {item}</p>
          ))}
        </div>
        <div className="boot-bar" aria-label={`Loading ${progress} percent`}>
          <span style={{ width: `${progress}%` }} />
        </div>
        <div className="boot-footer">
          <span>{progress}%</span>
          <button type="button" onClick={onComplete}>Press Space or Tap to Skip</button>
        </div>
      </div>
    </div>
  );
}

export default BootLoader;
